export default __webpack_public_path__ + "86b2a37c3bb5f5eddbf4ebc3a00466bc.svg";